import type { FC } from 'react';
import { lazy } from 'react';
import { useCapacityManagementRoot } from 'src/apis/capacity-management/use-capacity-management-root';
import { useInvoicesThreshold } from 'src/apis/capacity-management/use-invoices-threshold';
import { PageSpinner } from 'src/components/spinner-container';

const Page = lazy(() => import('./page'));

export const InvoicesSettings: FC = () => {
  const capacityManagementRoot = useCapacityManagementRoot();
  const invoicesThreshold = useInvoicesThreshold({
    capacityManagementRoot,
  });

  if (!capacityManagementRoot.response || !invoicesThreshold.response)
    return <PageSpinner />;

  return (
    <Page
      capacityManagementRoot={capacityManagementRoot}
      invoicesThresholdRequest={invoicesThreshold}
    />
  );
};
